export type CinemaItemState = {
  /**
 *
 */
  previosItemIndex: number;
  /**
 *
 */
  currentItemIndex: number;
  /**
 *
 */
  isEqual: () => boolean;
  /**
 *
 */
  synchronize: () => number;
};

/**
 *
 *
 *
 *
 *
 */
export const useItemState = (): CinemaItemState => {
  const state = $state({
    previosItemIndex: 0,
    currentItemIndex: 0,
    isEqual: () => state.previosItemIndex === state.currentItemIndex,
    synchronize: () => (state.previosItemIndex = state.currentItemIndex),
  });

  return state;
};
